/**
 * Get filter options
 * @param {array} photos
 * @returns {object}
 */
export default function getFilterOptions(photos) {
  let { descriptions, sources, taskNames } = photos.reduce(
    (parsed, photo) => {
      if (!!photo.description) {
        parsed.descriptions.push(photo.description.toUpperCase());
      }

      if (!!photo.source) {
        parsed.sources.push(photo.source.toUpperCase());
      }

      if (!!photo.taskName) {
        parsed.taskNames.push(photo.taskName.toUpperCase());
      }

      return parsed;
    },
    { descriptions: [], sources: [], taskNames: [] }
  );

  descriptions = [...new Set(descriptions)].sort();
  sources = [...new Set(sources)].sort();
  taskNames = [...new Set(taskNames)].sort();

  return { descriptions, sources, taskNames };
}
